import NavHeader from "./navheader.js";
import TopHeader from "./topheader.js";
import Footer from './footer.js';
import { Helmet } from "react-helmet";

export default function AllPage(props) {
    return (<>
        <Helmet>
            <title>{props.metaTitle ?? props.metaTitle}</title>
            <meta name="description" content={props.metaDescription || ""} />
        </Helmet>
        {props.showSubMenu ? 
        <NavHeader mode={props.menuLevel} navBrand={props.subMenuHeading} />
        : '' }
        <TopHeader MenuLevel={props.menuLevel} />
        {(props.hideFooter) ? '' :
        <Footer />
        }
    </>)
}